import * as React from "react";

import { styled } from "@mui/material/styles";

import { FormattedMessage } from "react-intl";

const PREFIX = "SkipToMainContentLink";

const classes = {
  link: `${PREFIX}-link`,
};

const Root = styled("a")(() => ({
  [`&.${classes.link}`]: {
    left: "1rem",
    top: "0.5rem",
    transform: "translateY(-150%)",
    zIndex: 10000,
    position: "absolute",
    padding: "1rem",
    fontSize: "1rem",
    backgroundColor: "#fff",
    color: "#000",
    border: "3px solid #000",
    borderRadius: "0.5rem",
    textDecoration: "none",
    transition: "transform 0.2s, opacity 0.2s",
    "&:focus": {
      transform: "translateY(0%)",
      opacity: 1,
    },
  },
}));

export function SkipToMainContentLink(): React.ReactNode {
  if (
    // eslint-disable-next-line @typescript-eslint/dot-notation
    window["UserWayWidgetApp"]?.lazyLoaded &&
    // eslint-disable-next-line @typescript-eslint/dot-notation
    !window["UserWayWidgetApp"]?.ContextHolder?.config?.tunings
      ?.widget_hidden_for_site
  ) {
    return null;
  }

  return (
    <Root className={classes.link} href="#main">
      <FormattedMessage
        defaultMessage="Skip to main content"
        description="Link to skip to main content"
      />
    </Root>
  );
}
